@if (commentItems.length > 0) {
    <div class="existing-comments">
        @for (item of commentItems; track item) {
            @if ($any(item).entity) {
                <adapt-chain-comment [chainItem]="$any(item)"
                                     [justAdded]="item === justAddedComment"
                                     (saving)="saving.emit($event.entity)"
                                     (saved)="saved.emit($event.entity)"
                                     (saveFailed)="
                        saveFailed.emit({
                            e: $event.e,
                            entity: $event.item.entity,
                        })
                    "
                                     (deleted)="onDeleted($event)">
                </adapt-chain-comment>
            }
            @if ($any(item).text) {
                <adapt-chain-update [chainUpdate]="$any(item)"
                                    (itemEdited)="chainUpdateEdited.emit($event)"
                                    (itemDeleted)="chainUpdateDeleted.emit($event)"> </adapt-chain-update>
            }
        }
    </div>
} @else {
    <div class="no-comment-text">
        {{ noCommentsText }}
    </div>
}

@if (newComment && newComment.canUpdate) {
    <adapt-add-comment [(newComment)]="newComment!.comment"
                       [commentingPerson]="newComment!.person"
                       [allowSave]="allowNewCommentSave"
                       [doSave]="saveNewComment"
                       [focusOnInit]="focusAddCommentOnInit"
                       data-test="add-comment"></adapt-add-comment>
}
